/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { MossRecipient, VerifiedSourceAccountDto } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class BeneficiaryBankAccountController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags beneficiary-bank-account-controller
   * @name GetVerifiedSourceAccountsAccountForCurrentOrganisation
   * @request GET:/api/v1/bank-accounts/verified-source-accounts
   */
  getVerifiedSourceAccountsAccountForCurrentOrganisation = (params: RequestParams = {}) =>
    this.http.request<VerifiedSourceAccountDto[], any>({
      path: `/v1/bank-accounts/verified-source-accounts`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getVerifiedSourceAccountsAccountForCurrentOrganisationPath =
    '/v1/bank-accounts/verified-source-accounts'
  static getVerifiedSourceAccountsAccountForCurrentOrganisationMethod = 'GET'
  /**
   * No description
   *
   * @tags beneficiary-bank-account-controller
   * @name GetBeneficiaryBankAccountForCurrentOrganisation
   * @request GET:/api/v1/bank-accounts/beneficiary
   */
  getBeneficiaryBankAccountForCurrentOrganisation = (params: RequestParams = {}) =>
    this.http.request<MossRecipient, any>({
      path: `/v1/bank-accounts/beneficiary`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getBeneficiaryBankAccountForCurrentOrganisationPath = '/v1/bank-accounts/beneficiary'
  static getBeneficiaryBankAccountForCurrentOrganisationMethod = 'GET'
}
